class SpillToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-spill-toggle]');
    if (!this.button) return;

    this.kvmInput = document.querySelector('#s-feet');
    this.qtyInput = document.querySelector('input[name="quantity"]');

    this.active = this.dataset.defaultOn !== 'false';
    this.updateButtonState();

    this.button.addEventListener('click', () => {
      this.active = !this.active;
      this.updateButtonState();
      this.recompute();
    });

    if (this.kvmInput) {
      this.kvmInput.addEventListener('input', () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.recompute(), 30);
      });
    }
  }

  updateButtonState() {
    this.button.setAttribute('aria-pressed', this.active ? 'true' : 'false');
    this.button.classList.toggle('is-active', this.active);
  }

  recompute() {
    if (this._isInternal) return;
    if (!this.kvmInput || !this.qtyInput) return;

    const kvm = parseFloat(this.kvmInput.value) || 0;
    if (kvm <= 0) return;

    const vpu = parseFloat(this.kvmInput.dataset.vpu) || 0;
    if (!vpu) return;

    const baseBoxes = Math.max(1, Math.ceil(kvm / vpu));
    const targetBoxes = this.active
      ? Math.max(1, Math.ceil((kvm * 1.1) / vpu))
      : baseBoxes;

    if (parseInt(this.qtyInput.value, 10) === targetBoxes) return;

    this._isInternal = true;
    this.qtyInput.value = targetBoxes;
    this.qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    queueMicrotask(() => { this._isInternal = false; });
  }
}

if (!customElements.get('spill-toggle')) {
  customElements.define('spill-toggle', SpillToggle);
}